import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import IpoPage from "@/pages/IpoPage";
import UsersPage from "@/pages/UsersPage";
import AnggotaPage from "@/pages/AnggotaPage";
import SaldoPage from "@/pages/SaldoPage";
import DashboardAnggota from "@/pages/DashboardAnggota";
import DirektoriAkun from "@/pages/DirektoriAkun";

function Guard({ children, adminOnly }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        <span className="animate-pulse font-mono-num text-sm">memuat…</span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/dashboard" replace />;
  return <Shell>{children}</Shell>;
}

function Root() {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={isAdmin ? "/ipo" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Root />} />
            <Route path="/ipo" element={<Guard><IpoPage /></Guard>} />
            <Route path="/dashboard" element={<Guard><DashboardAnggota /></Guard>} />
            <Route path="/dashboard/:nama" element={<Guard><DashboardAnggota /></Guard>} />
            <Route path="/pengguna" element={<Guard adminOnly><UsersPage /></Guard>} />
            <Route path="/anggota" element={<Guard adminOnly><AnggotaPage /></Guard>} />
            <Route path="/saldo" element={<Guard adminOnly><SaldoPage /></Guard>} />
            <Route path="/direktori" element={<Guard><DirektoriAkun /></Guard>} />            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
